module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "alert",
    class: {
      'alert': true,
      'alert-dismissable': true,
      'alert-success': _vm.isSuccess,
      'alert-danger': _vm.isError,
      'alert-warning': _vm.isWarning,
      'alert-info': _vm.isInfo
    }
  }, [_c('i', {
    staticClass: "ti ti-check"
  }), _vm._v("\n     \n    "), _c('strong', [_vm._v(_vm._s(_vm.title))]), _vm._v("\n    " + _vm._s(_vm.message) + "\n    "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("×")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76964c8f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Alert.vue
// module id = 882
// module chunks = 1